import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@app-services/auth.service';
import { NotificationService } from '@app-services/notification.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.handleUnauthorized();
        }
        return throwError(() => error);
      })
    );
  }

  private handleUnauthorized(): void {
    // Show notification to user
    this.notificationService.warning(
      'Session Expired',
      'Your authentication session has expired. Please log in again.',
      5000
    );

    // Clear user data and logout
    this.authService.logout();

    // Redirect to login page
    this.router.navigate(['/auth/login']);
  }
}

export const authErrorInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
];

